export const initialErrorValidation = {
  awbNumber: null,
  dispatchNumber: null
};

export function useShippingLabelValidation(initialForm) {
  const { awbNumber, dispatchNumber } = initialForm;

  const awbNumberMessage = () => {
    if (awbNumber === "") {
      return "This field is required.";
    }
    return null;
  };

  const dispatchNumberMessage = () => {
    if (dispatchNumber === "") {
      return "This field is required.";
    }
    return null;
  };

  return {
    awbNumber: awbNumberMessage(),
    dispatchNumber: dispatchNumberMessage()
  };
}

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
